/** Standard width for event composer side drawers (space booking, time suggestions, etc.) */
export var COMPOSER_DRAWER_WIDTH = 340;
